import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import immer from 'immer';
export default (function (Table) {
  return (
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(_class, _React$Component);

      var _super = _createSuper2(_class);

      function _class(props) {
        var _this;

        _classCallCheck(this, _class);

        _this = _super.call(this, props);
        _this.handleResize = _this.handleResize.bind(_assertThisInitialized(_this));
        _this.state = {
          columns: props.columns,
          delta: 0
        };
        return _this;
      }

      _createClass(_class, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var _this2 = this;

          var prevColumns = prevProps.columns;
          var _this$props = this.props,
              columns = _this$props.columns,
              onColumnResize = _this$props.onColumnResize;

          if (prevColumns !== columns) {
            if (prevColumns.length !== columns.length) {
              // eslint-disable-next-line react/no-did-update-set-state
              this.setState({
                columns: columns
              });
            } else {
              var widthed = onColumnResize ? columns : immer(columns, function (draft) {
                draft.forEach(function (column, index) {
                  column.width = _this2.state.columns[index].width;
                });
              }); // eslint-disable-next-line react/no-did-update-set-state

              this.setState({
                columns: widthed
              });
            }
          }
        }
      }, {
        key: "getWidth",
        value: function getWidth() {
          var width = this.props.width;
          var columns = this.state.columns;

          if (typeof width === 'number') {
            var sum = columns.reduce(function (s, col) {
              return s + (col.width || 0);
            }, 0);
            var w = width + this.state.delta;
            return w > sum ? w : sum;
          }

          return width;
        }
      }, {
        key: "handleResize",
        value: function handleResize(index, width, colgroup) {
          if (colgroup === undefined) return;
          var onColumnResize = this.props.onColumnResize;
          var changed = immer(this.state, function (draft) {
            var column = draft.columns[index]; // @ts-ignore

            draft.delta += parseFloat(width - (column.width || colgroup[index] || 0));
            colgroup[index] = width;
            draft.columns.forEach(function (col, i) {
              var w = colgroup[i];
              if (w) col.width = w;
            });
          });

          if (onColumnResize) {
            onColumnResize(changed.columns);
            return;
          }

          this.setState(changed);
        }
      }, {
        key: "render",
        value: function render() {
          var columns = this.state.columns;

          var _this$props2 = this.props,
              onColumnResize = _this$props2.onColumnResize,
              other = _objectWithoutProperties(_this$props2, ["onColumnResize"]);

          var width = this.getWidth();
          return (
            /*#__PURE__*/
            React.createElement(Table, Object.assign({}, other, {
              width: width,
              columns: columns,
              onResize: this.handleResize
            }))
          );
        }
      }]);

      return _class;
    }(React.Component)
  );
});